import { Dispatch, Action } from 'redux';
import { AppState } from '..';
import { ContractViewModel, ContractResaleModalViewModel } from '@models/Contract';
import { actions } from 'react-redux-form';
import { contractService } from '@services/ContractService';
import { PriceAdjustmentViewModel } from '@models/Product';
import { ToastComponent, ToastType } from '@common/components';
import { ToastOptions } from '@common/components/toast/toast';
import * as React from 'react';
import { toast } from 'react-toastify';
// import { realEstateOfficesService } from '@services/RealEstateOfficesService';
// import { realEstateAgentsService } from '@services/RealEstateAgentsService';
// import { RealEstateOfficeViewModel } from '@models/RealEstateOffice';
// import { RealEstateAgentViewModel } from '@models/RealEstateAgent';
import { ContractResaleEmailViewModel } from '@models/Contract';
import {
  setPriceAdjustmentSelection,
  loadCoverageState,
  setPriceAdjustmentAmount
} from './_components/coverage/_actions/coverage.actions';
import { CoverageState, initialCoverageState } from './_components/coverage/coverage.reducer';
import { dateParser } from '@common/dateParser';
import FormNames from '@constants/FormNames.enum';

export enum ContractResaleActionType {
  ResellContract = 'ResellContract',
  GetContractResaleDataStart = 'GetContractResaleDataStart',
  GetContractResaleDataSuccess = 'GetContractResaleDataSuccess',
  GetContractResaleDataFailure = 'GetContractResaleDataFailure',
  ClearResaleData = 'ClearResaleData',
  SaveResaleContractStart = 'SaveResaleContractStart',
  SaveResaleContractSuccess = 'SaveResaleContractSuccess',
  SaveResaleContractFailure = 'SaveResaleContractFailure',
  GetContractResaleNotificationsStart = 'GetContractResaleNotificationsStart',
  GetContractResaleNotificationsSuccess = 'GetContractResaleNotificationsSuccess',
  GetContractResaleNotificationsFailure = 'GetContractResaleNotificationsFailure',
  AddEmailNotificationResale = 'AddEmailNotificationResale',
  RemoveEmailNotificationResale = 'RemoveEmailNotificationResale',
  SendResaleEmailsStart = 'SendResaleEmailsStart',
  SendResaleEmailsSuccess = 'SendResaleEmailsSuccess',
  SendResaleEmailsFailure = 'SendResaleEmailsFailure',
  SetResaleDate = 'SetResaleDate',
  SetResaleLoading = 'SetResaleLoading'
}

export interface ContractResellAction extends Action {
  readonly type: ContractResaleActionType.ResellContract;
  readonly contractVM: ContractViewModel;
  /*  readonly agent: RealEstateAgentViewModel;
  readonly office: RealEstateOfficeViewModel;
  readonly coopagent: RealEstateAgentViewModel;
  readonly coopAgentOffice: RealEstateOfficeViewModel; */
}

export interface GetContractResaleDataStartAction extends Action {
  readonly type: ContractResaleActionType.GetContractResaleDataStart;
}

export interface GetContractResaleDataSuccessAction extends Action {
  readonly type: ContractResaleActionType.GetContractResaleDataSuccess;
  readonly contractResaleModalVM: ContractResaleModalViewModel;
}

export interface SetResaleLoadingAction extends Action {
  readonly type: ContractResaleActionType.SetResaleLoading;
  readonly isLoading: boolean;
}

export interface GetContractResaleDataFailureAction extends Action {
  readonly type: ContractResaleActionType.GetContractResaleDataFailure;
  readonly message: string;
}

export interface ClearResaleDataAction extends Action {
  readonly type: ContractResaleActionType.ClearResaleData;
}

export interface SaveResaleContractStartAction extends Action {
  readonly type: ContractResaleActionType.SaveResaleContractStart;
}

export interface SaveResaleContractSuccessAction extends Action {
  readonly type: ContractResaleActionType.SaveResaleContractSuccess;
  readonly id: number;
}

export interface SaveResaleContractFailureAction extends Action {
  readonly type: ContractResaleActionType.SaveResaleContractFailure;
  readonly error: string;
}

export interface GetContractResaleNotificationsStartAction extends Action {
  readonly type: ContractResaleActionType.GetContractResaleNotificationsStart;
}

export interface GetContractResaleNotificationsSuccessAction extends Action {
  readonly type: ContractResaleActionType.GetContractResaleNotificationsSuccess;
  readonly resaleNotifications: Array<ContractResaleEmailViewModel>;
}

export interface GetContractResaleNotificationsFailureAction extends Action {
  readonly type: ContractResaleActionType.GetContractResaleNotificationsFailure;
  readonly error: string;
}

export interface AddEmailNotificationResaleAction extends Action {
  readonly type: ContractResaleActionType.AddEmailNotificationResale;
  readonly email: string;
}

export interface RemoveEmailNotificationResaleAction extends Action {
  readonly type: ContractResaleActionType.RemoveEmailNotificationResale;
  readonly email: string;
}

export interface SendResaleEmailsStartAction extends Action {
  readonly type: ContractResaleActionType.SendResaleEmailsStart;
  readonly message: string;
}

export interface SendResaleEmailsSuccessAction extends Action {
  readonly type: ContractResaleActionType.SendResaleEmailsSuccess;
  readonly message: string;
}

export interface SendResaleEmailsFailureAction extends Action {
  readonly type: ContractResaleActionType.SendResaleEmailsFailure;
  readonly message: string;
}

export interface SetResaleDateAction extends Action {
  readonly type: ContractResaleActionType.SetResaleDate;
  readonly date: Date;
  readonly resaleContractId: number;
}

export function resaleDataLoader(contractVM: ContractViewModel) {
  return async (dispatch: Dispatch<AppState>) => {
    try {
      /* let agent: RealEstateAgentViewModel | null = null;
      let coopagent: RealEstateAgentViewModel | null = null;
      var coopAgentOffice = undefined;
      var office = undefined;
     if (contractVM.initAgentId) {
        agent = await realEstateAgentsService.get(contractVM.initAgentId);
      }
      if (contractVM.coopAgentId) {
        coopagent = await realEstateAgentsService.get(contractVM.coopAgentId);
      }
      if (contractVM.coopOfficeId) {
        coopAgentOffice = await realEstateOfficesService.get(contractVM.coopOfficeId);
      }
      if (contractVM.initOfficeId) {
        office = await realEstateOfficesService.get(contractVM.initOfficeId);
      }*/
      dispatch(moveDataToContract(contractVM)); // , agent!, office!, coopagent!, coopAgentOffice!));
    } catch (e) {
      console.log(e.message);
    }
  };
}
export function moveDataToContract(
  contractVM: ContractViewModel
  /*  agent: RealEstateAgentViewModel,
  office: RealEstateOfficeViewModel,
  coopagent: RealEstateAgentViewModel,
  coopAgentOffice: RealEstateOfficeViewModel */
): ContractResellAction {
  return {
    type: ContractResaleActionType.ResellContract,
    contractVM: contractVM
    /*  agent: agent,
    office: office,
    coopagent: coopagent,
    coopAgentOffice: coopAgentOffice */
  };
}

/**** Contract Resale ****/
export function loadContractInfoForResale(id: number, premium: number, resaleDate: Date) {
  return async (dispatch: Dispatch<AppState>) => {
    try {
      const contractVM = await contractService.getResaleContract(id);
      // TODO: Fix with updated viewmodel after endpoint is fixed.
      if (contractVM) {
        let newContractVM: ContractViewModel = {
          ...contractVM,
          resaleId: contractVM.id,
          id: 0,
          additionalRealEstateAgentIds: []
        };

        await dispatch(resaleDataLoader(newContractVM));
        newContractVM.yearBuilt = newContractVM.yearBuilt ? '' + newContractVM.yearBuilt : '';
        await dispatch(
          actions.change(FormNames.PropertyInfoForm, {
            propertySaleType: { id: 7, value: 'Resale' },
            contactName: '',
            contactType: null,
            contactMedium: null,
            contactInit: null,
            propertyAddress: newContractVM.propertyAddress,
            mailReturned: newContractVM.mailReturned,
            propertyType: newContractVM.propertyType,
            yearBuilt: newContractVM.yearBuilt
          })
        );
        await dispatch(
          actions.change(FormNames.AffiliatesInfoForm, {
            // initAgentId: newContractVM.initAgentId,
            // initOfficeId: newContractVM.initOfficeId,
            // coopAgentId: newContractVM.coopAgentId,
            // coopOfficeId: newContractVM.coopOfficeId,
            // additionalRealEstateAgentIds: newContractVM.additionalRealEstateAgentIds,

            propertyManagerId: 0,

            // Reset Escrow Info Section
            escrowOfficerId: 0,
            escrowOneTimeFax: '',
            fileNumber: '',
            estimatedCoeDate: dateParser.parse(dateParser.toDateString(resaleDate)).toDate(),
            transCoordId: 0,
            txCOneTimeFax: ''
          })
        );
        await dispatch(
          actions.change(FormNames.CustomerInfoForm, {
            sellerId: 0,
            buyerId: 0
          })
        );
        // dispatch(
        //   actions.change('escrowInfoForm', {
        //     escrowOfficerId: 0,
        //     escrowOneTimeFax: '',
        //     fileNumber: '',
        //     estimatedCoeDate: '',
        //     transCoordId: 0,
        //     txCOneTimeFax: ''
        //   })
        // );

        const coverageState: CoverageState = {
          ...initialCoverageState,
          selectedProductGroup: newContractVM.productGroup || { id: (newContractVM.product || {}).productGroupId },
          selectedProductChannel: newContractVM.productChannel || {
            id: (newContractVM.product || {}).productChannelId
          },
          selectedProduct: { ...newContractVM.product },
          selectedCoverageOptions: newContractVM.coverageOptions,
          sellerCoverage: newContractVM.sellerCoverage,
          selectedPriceAdjustment: newContractVM.priceAdjustment,
          // overridePriceAdjustmentAmount: premium,
          selectedGroupId: newContractVM.product.productGroupId,
          selectedChannelId: newContractVM.product.productChannelId
        };
        await dispatch(loadCoverageState(coverageState));

        await dispatch(
          setPriceAdjustmentSelection({
            id: 19,
            value: 'Resale Proration',
            increase: false,
            adjustmentAmount: premium,
            percentageAmount: 0
          } as PriceAdjustmentViewModel)
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
}

export function getContractResaleData(id?: number, date?: Date, shouldSetPriceAdjustment?: boolean, isEdit?: boolean) {
  return async (dispatch: Dispatch<AppState>) => {
    if (id) {
      dispatch(getContractResaleDataStart());
      try {
        const contractResaleModalVM = await contractService.getContractResaleData(id, date, isEdit);
        dispatch(getContractResaleDataSuccess(contractResaleModalVM));
        if (shouldSetPriceAdjustment) {
          dispatch(
            setPriceAdjustmentSelection({
              id: 19,
              value: 'Resale Proration',
              increase: false,
              adjustmentAmount: Number(contractResaleModalVM.credit.slice(1)),
              percentageAmount: 0
            } as PriceAdjustmentViewModel)
          );
          dispatch(setPriceAdjustmentAmount(Number(contractResaleModalVM.credit.slice(1))));
        }
      } catch (e) {
        dispatch(getContractResaleDataFailure(e.toString()));
      }
    }
    return;
  }; // TODO *****
}

export function setResaleLoading(loading: boolean): SetResaleLoadingAction {
  return {
    type: ContractResaleActionType.SetResaleLoading,
    isLoading: loading
  };
}

export function getContractResaleDataStart(): GetContractResaleDataStartAction {
  return {
    type: ContractResaleActionType.GetContractResaleDataStart
  };
}

export function getContractResaleDataSuccess(
  contractResaleModalVM: ContractResaleModalViewModel
): GetContractResaleDataSuccessAction {
  return {
    type: ContractResaleActionType.GetContractResaleDataSuccess,
    contractResaleModalVM: contractResaleModalVM
  };
}

export function getContractResaleDataFailure(error: string): GetContractResaleDataFailureAction {
  return {
    type: ContractResaleActionType.GetContractResaleDataFailure,
    message: error
  };
}

export function clearResaleData(): ClearResaleDataAction {
  return {
    type: ContractResaleActionType.ClearResaleData
  };
}

export function saveResaleContract(model: ContractViewModel) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(saveResaleContractStart());
    try {
      if (model.transactionCoordinatorIds && model.transactionCoordinatorIds.length > 0) {
        model.transCoordId = model.transactionCoordinatorIds[0].id;
        var transCoords = model.transactionCoordinatorIds.slice(1);
        transCoords.forEach(tc => {
          model.contractEntities.push({
            id: 0,
            contractId: 0,
            transactionCoordinatorId: tc.id
          });
        });
        model.additionalRealEstateAgentIds.forEach(ra => {
          model.contractEntities.push({
            id: 0,
            contractId: 0,
            realEstateAgentId: ra
          });
        });
      }
      if (model.resaleId) {
        var newResalecontractId = await contractService.saveResaleContract(model, model.resaleId);
      }
      dispatch(saveResaleContractSuccess(newResalecontractId!));
    } catch (e) {
      dispatch(saveResaleContractFailure(e.message));
    }
  };
}

export function saveResaleContractStart(): SaveResaleContractStartAction {
  return {
    type: ContractResaleActionType.SaveResaleContractStart
  };
}

export function saveResaleContractSuccess(id: number): SaveResaleContractSuccessAction {
  toast.success(
    <ToastComponent type={ToastType.Success} message={`Contract Saved Successfully`} />,
    ToastOptions.Success
  );
  return {
    type: ContractResaleActionType.SaveResaleContractSuccess,
    id: id
  };
}

export function saveResaleContractFailure(error: string): SaveResaleContractFailureAction {
  toast.error(<ToastComponent type={ToastType.Error} message={error} />, ToastOptions.Error);
  return {
    type: ContractResaleActionType.SaveResaleContractFailure,
    error: error
  };
}

export function getContractResaleNoticiations(id: number) {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(getContractResaleNotificationsStart());
    try {
      const notifications: Array<
        ContractResaleEmailViewModel
      > = await contractService.getContractResaleEmailNotifications(id);
      dispatch(getContractResaleNotificationsSuccess(notifications));
    } catch (e) {
      dispatch(getContractResaleNotificationsFailure(e.toString()));
    }
  };
}

export function getContractResaleNotificationsStart(): GetContractResaleNotificationsStartAction {
  return {
    type: ContractResaleActionType.GetContractResaleNotificationsStart
  };
}

export function getContractResaleNotificationsSuccess(
  resaleNotifications: Array<ContractResaleEmailViewModel>
): GetContractResaleNotificationsSuccessAction {
  return {
    type: ContractResaleActionType.GetContractResaleNotificationsSuccess,
    resaleNotifications: resaleNotifications
  };
}

export function getContractResaleNotificationsFailure(error: string): GetContractResaleNotificationsFailureAction {
  return {
    type: ContractResaleActionType.GetContractResaleNotificationsFailure,
    error: error
  };
}

export function addEmail(email: string) {
  return (dispatch: Dispatch<AppState>) => {
    dispatch(actions.push('contractResaleEmailForm.resaleEmails', email));
    dispatch(addEmailNotificationSuccess(email));
  };
}

export function addEmailNotificationSuccess(email: string): AddEmailNotificationResaleAction {
  return {
    type: ContractResaleActionType.AddEmailNotificationResale,
    email: email
  };
}

export function removeEmail(email: string) {
  return (dispatch: Dispatch<AppState>) => {
    dispatch(actions.filter('contractResaleEmailForm.resaleEmails', (value: any) => value !== email));
    dispatch(removeEmailNotificationSuccess(email));
  };
}

export function removeEmailNotificationSuccess(email: string): RemoveEmailNotificationResaleAction {
  return {
    type: ContractResaleActionType.RemoveEmailNotificationResale,
    email: email
  };
}

export function sendResaleEmails(id: number, emails: Array<string>) {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    let emailNotifications: Array<string> = [];
    const state = getState();
    const emailState = state.contract.resaleNotifications;
    const additionalEmails = state.contract.resaleEmailNotifications;
    if (emailState) {
      emails.map((value, index) => {
        if (value) {
          emailNotifications.push(emailState[index].email);
        }
      });
    }
    if (additionalEmails) {
      additionalEmails.map((value, index) => {
        if (value && value.length > 0) {
          emailNotifications.push(value);
        }
      });
    }
    dispatch(sendResaleEmailsStart());
    try {
      await contractService.sendResaleEmails(id, emailNotifications);
      dispatch(sendResaleEmailsSuccess(true));
    } catch (e) {
      dispatch(sendResaleEmailsFailure(e.toString()));
    }
  };
}

export function cancleResaleEmails() {
  return async (dispatch: Dispatch<AppState>) => {
    dispatch(sendResaleEmailsSuccess(false));
  };
}

export function sendResaleEmailsStart() {
  return {
    type: ContractResaleActionType.SendResaleEmailsStart
  };
}

export function sendResaleEmailsSuccess(showToast: boolean) {
  if (showToast) {
    toast.success(
      <ToastComponent type={ToastType.Success} message={`Emails Sent Successfully!`} />,
      ToastOptions.Success
    );
  }
  return {
    type: ContractResaleActionType.SendResaleEmailsSuccess
  };
}

export function sendResaleEmailsFailure(error: string) {
  toast.error(<ToastComponent type={ToastType.Error} message={error} />, ToastOptions.Error);
  return {
    type: ContractResaleActionType.SendResaleEmailsFailure,
    message: error
  };
}



// WEBPACK FOOTER //
// ./src/contract/contract-resale.actions.tsx